import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import ConsultationDatatableHandler from "@Modules/interfaceManagement/visaBase2/containers/tableHandlers/issuer/request/consultation/ConsultationDatatableHandler";

export default function Consultation() {
  return (
    <>
      <CC.Box>
        <CC.Text fontSize={20} fontWeight="bold" mb="4">
        Retrieval request inquiry
        </CC.Text>
        <ConsultationDatatableHandler />
      </CC.Box>
    </>
  );
}